import { observer } from 'mobx-react';
import { Component } from 'react';

import { RedirectionWarningModalTranslation } from '../../../localization/SiteTranslation';
import Modal from '../Modal/Modal';
import HeaderLevel2 from '../Typography/HeaderLevel2';
import HeaderLevel3 from '../Typography/HeaderLevel3';
import RedirectionWarningModalState from './RedirectionWarningModalState';
import css from './RedirectionWarningModalState.css';

export interface RedirectionWarningModalProps {
  modal: RedirectionWarningModalState;
  translation: RedirectionWarningModalTranslation;
}

@observer
export default class RedirectionWarningModal extends Component<RedirectionWarningModalProps, {}> {
  render() {
    const { modal, translation } = this.props;
    return (
      <Modal modal={modal} className={css.StoreSelectorModal} contentClassName={css.content} translation={translation}>
        <HeaderLevel3>{translation.title}</HeaderLevel3>
        <HeaderLevel2 className={css.number}>
          <span>{modal.timeout}</span>
        </HeaderLevel2>
      </Modal>
    );
  }
}
